import FormTags from "../FormTags/FormTags";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroTags.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import TagService from "../../../services/TagService";

const CadastroTags = () => {
	const { tagId } = useParams();
	const { state } = useLocation();
	const [tag, setTag] = useState(state);
	const [type, setType] = useState("");

	async function loadTag(id) {
		const response = await TagService.getOne(id);
		if (response.data) {
			setTag(response.data);
		}
	}

	useEffect(() => {
		setType(tagId || state ? "edicao" : "cadastro");

		if (tag) {
			setTag(state);
			return;
		}

		if (tagId) {
			loadTag(tagId);
		}
	}, [state, tagId]);

	return (
		<CadastroContainer>
			<FormTags tag={tag} type={type} />
		</CadastroContainer>
	);
};

export default CadastroTags;
